var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46085 1.23453L5.16085 3.53453L2.29085 0.644531L0.87085 2.06453L3.76085 4.93453L1.46085 7.23453H7.46085V1.23453Z",
    fill: "#EFF6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46085 9.16016L3.76085 11.4602L0.87085 14.3302L2.29085 15.7502L5.16085 12.8602L7.46085 15.1602V9.16016H1.46085Z",
    fill: "#EFF6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1611 15.1602L12.4611 12.8602L15.3311 15.7502L16.7511 14.3302L13.8611 11.4602L16.1611 9.16016H10.1611V15.1602Z",
    fill: "#EFF6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1611 7.23453L13.8611 4.93453L16.7511 2.06453L15.3311 0.644531L12.4611 3.53453L10.1611 1.23453V7.23453H16.1611Z",
    fill: "#EFF6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomDefaultIcon);
export default __webpack_public_path__ + "static/media/ZoomDefaultIcon.80de3a3f.svg";
export { ForwardRef as ReactComponent };